import {
  Flex,
  Text,
  Menu,
  Modal,
  Button,
  Avatar,
  Divider,
  MenuList,
  MenuItem,
  ModalBody,
  MenuButton,
  ModalOverlay,
  ModalContent,
  useDisclosure,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "context/UserContext";

const HeaderDropdown = () => {
  const navigate = useNavigate();
  const { user, signOut } = useUserContext();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Menu matchWidth>
        <MenuButton
          as={Button}
          bg="#000000"
          color="#FFFFFF"
          px={4}
          py={6}
          borderRadius="12px"
          _hover={{ bg: "blackAlpha.800" }}
          _active={{ bg: "#000000" }}
          rightIcon={<ChevronDownIcon />}
        >
          <Flex align="center" gap={3}>
            <Avatar
              size="xs"
              name={`${user?.info?.first_name} ${user?.info?.surname}`}
            />
            <Text
              fontSize={"12px"}
              fontFamily="PlusJakartaSansBold"
              color={"#FFFFFF"}
            >
              {user?.info?.first_name} {user?.info?.surname}
            </Text>
          </Flex>
        </MenuButton>
        <MenuList
          boxShadow={"md"}
          border={"none"}
          borderRadius="12px"
          p={4}
          gap={2}
          display={"flex"}
          flexDirection={"column"}
          minW="unset"
          w="full"
          mt={1}
          zIndex={10}
        >
          <MenuItem
            onClick={(event) => {
              event.preventDefault();
              navigate("/profile");
            }}
            borderRadius={"6px"}
            _hover={{ bg: "#8A8F9333" }}
            fontSize={"12px"}
            fontFamily="PlusJakartaSansRegular"
            color={"#000000"}
            py={2}
          >
            Profile
          </MenuItem>
          <Divider color={"#8A8F9333"} />

          {/* <MenuItem
            onClick={(event) => {
              event.preventDefault();
              navigate("/notifications");
            }}
            borderRadius={"6px"}
            _hover={{ bg: "#8A8F9333" }}
            fontSize={"12px"}
            fontFamily="PlusJakartaSansRegular"
            color={"#000000"}
            py={2}
          >
            Notifications
          </MenuItem> */}
          <Divider color={"#8A8F9333"} />
          <MenuItem
            borderRadius={"6px"}
            _hover={{ bg: "#8A8F9333" }}
            fontSize={"12px"}
            fontFamily="PlusJakartaSansRegular"
            color={"#000000"}
            py={2}
            onClick={(event) => {
              event.preventDefault();
              onOpen();
            }}
          >
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
      <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
        <ModalOverlay />
        <ModalContent maxWidth={"800px"} borderRadius={"16px"} p={6}>
          <ModalBody
            gap={4}
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
          >
            <Text
              fontSize={"24px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              color={"#000000"}
            >
              Are you Sure?
            </Text>
            <Text
              fontSize={"16px"}
              fontFamily={"PlusJakartaSansRegular"}
              color={"#000000"}
            >
              Do you wish to logout of the Seller App?
            </Text>
            <Flex justifyContent={"center"} gap={3} pt={6}>
              <Button
                onClick={onClose}
                width={"174px"}
                height={"40px"}
                borderRadius={"12px"}
                bg={"none"}
                border={"1px solid #000000"}
                color={"#000000"}
                fontSize={"12px"}
                fontWeight={"500"}
                fontFamily={"PlusJakartaSansMedium"}
                letterSpacing={0.2}
              >
                NO
              </Button>
              <Button
                onClick={() => signOut()}
                width={"174px"}
                height={"40px"}
                borderRadius={"12px"}
                bg={"#000000"}
                color={"white"}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                fontWeight={"500"}
                letterSpacing={0.2}
              >
                YES
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default HeaderDropdown;
